import React, { useState, useRef, useContext, Redirect, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import UploadedOrders from '../UploadedOrders/UploadedOrders';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CurrentOrdersTable from '../PIDashboard/CurrentOrders_Updated/CurrentOrdersTable';
import CurrentResearchersTable from '../PIDashboard/Researchers/CurrentResearchersTable';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { SnackbarProvider } from 'notistack';
import { socket, SocketContext } from '../../context/socket';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import BillingSummaryChart from '../PIDashboard/BillingSummary/BillingSummaryChart';

import { useSnackbar } from 'notistack';
import AuthContext from '../../auth/auth';

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
async function getMyData({
  setMyData,
  setMyOrderReceived,
  myOrdersReceived,
  user,
}) {
  if (myOrdersReceived === false) {
    try {
      const res = await axios.get(
        API_ENDPOINT + '/clientOrders/droppedOffOrder',
        {
          params: {
            username: user.casUser,
          },
        }
      );
      let myData = [];
      res.data.forEach((element) => {
          let oneRow = {};
          Object.keys(element).forEach((el) => {
            if (el == '__v') {
            } else {
              oneRow = { ...oneRow, [el]: element[el] };
            }
          });
          myData = [...myData, oneRow];
      });
      setMyData(myData);
      setMyOrderReceived(true);
    } catch (error) {
      console.log(error);
    }
  } else {
    //DO Nothing
  }
}

async function getInitialData({
  setData,
  setOrderReceived,
  ordersReceived,
  user,
}) {
  if (ordersReceived === false) {
    try {
      const res = await axios.get(
        API_ENDPOINT + '/clientOrders/piOrders',
        {
          params: {
            username: user.casUser,
          },
        }
      );
      let dataToBeUsed = [];
      res.data.forEach((element) => {
          let oneRow = {};
          Object.keys(element).forEach((el) => {
            if (el == '__v') {
            } else {
              oneRow = { ...oneRow, [el]: element[el] };
            }
          });
          dataToBeUsed = [...dataToBeUsed, oneRow];
      });
      setData(dataToBeUsed);
      setOrderReceived(true);
    } catch (error) {
      console.log(error);
    }
  } else {
    //DO Nothing
  }
}

const getIsPI = async (username) => {
  var res;
  res = await axios({
      url: API_ENDPOINT + "/user/per",
      method: 'GET',
      params: {
          username: username
      }
  })
  return res.data.isPI;
}

function Orders(props) {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [current, setCurrent] = React.useState('all');
  const [data, setData] = useState([]);
  const [myData, setMyData] = useState([]);
  const [ordersReceived, setOrderReceived] = useState(false);
  const [myOrdersReceived, setMyOrderReceived] = useState(false);

  const [isPI, setIsPI] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const user = useContext(AuthContext);

  axios
    .get(API_ENDPOINT + '/user/new', {username: user.casUser})
    .then((res) => {
      if (res.status === 200) {
        // Do Nothing
      }
    })
    .catch(function (error) {
      if (error.response.status === 302) {
        navigate('/profile', { replace: true });
      }
    });
  
  useEffect(() => {
    getIsPI(user.casUser)
    .then((data) => {
      setIsPI(data);
    })
  }, [])
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleCurrentTableChange = (event, newValue) => {
    setCurrent(newValue)
  }

  useEffect(() => {
    socket.on('updateOthersUploadedOrders', (msg) => {
      //console.log("run");
      setOrderReceived(false);
      enqueueSnackbar(msg, { variant: 'info' });
    });
  }, []);

  useEffect(() => {
    socket.on('updateSelfUploadedOrders', () => {
      //console.log("run");
      setOrderReceived(false);
    });
  }, []);

  useEffect(() => {
    socket.on('connect', () => console.log(socket.id));
    socket.on('connect_error', () => {
      setTimeout(() => socket.connect(), 5000);
    });
    socket.on('disconnect', () => console.log('Server disconnected'));
  }, []);

  useEffect(() => {
    getInitialData({
      setData,
      setOrderReceived,
      ordersReceived,
      user,
    }).catch(console.error);
  }, [ordersReceived]);

  useEffect(() => {
    //console.log("run");
    getMyData({
      setMyData,
      setMyOrderReceived,
      myOrdersReceived,
      user,
    }).catch(console.error);
  }, [myOrdersReceived]);
  
  if (isPI === false) {
    return (
      <Container>
        <Row>
          <UploadedOrders />
        </Row>
        <br></br>
        <br></br>
        <Row>
          <CurrentOrdersTable orders={myData} />
        </Row>
      </Container>
    );
  } else {
    return (
      <Grid container
        direction="column"
        alignItems="center"
        spacing={0}
        margin={0}>
        <Row>
          <UploadedOrders />
        </Row>
        <br></br>
        <SocketContext.Provider  value={socket}>
          <SnackbarProvider maxSnack={3}>
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs 
                  value={value} 
                  onChange={handleChange} 
                  aria-label="basic tabs example"
                >
                  <Tab label="Orders" {...a11yProps(0)} />
                  <Tab label="Researchers" {...a11yProps(1)} />
                  <Tab label="Billing Summary" {...a11yProps(2)} />
                  <div style={{marginLeft: "auto"}}>
                  </div>
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <Container>
                  <FormControl component="fieldset">
                    <RadioGroup row aria-label="position" name="position" defaultValue="all" onChange={handleCurrentTableChange}>
                      <FormControlLabel value="all" control={<Radio color="primary" />} label="All Orders" />
                      <FormControlLabel value="onlyMy" control={<Radio color="primary" />} label="Only My Orders" />
                    </RadioGroup>
                  </FormControl>
                  <br></br>
                  <br></br>
                  <Row>
                    {current == 'all' ? 
                    <CurrentOrdersTable orders={data}/>
                    : <CurrentOrdersTable orders={myData}/>}
                  </Row>
                </Container>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Container>
                  <Row>
                    <CurrentResearchersTable />
                  </Row>
                </Container>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <BillingSummaryChart orders={data}/>
              </TabPanel>
            </Box>
          </SnackbarProvider>
        </SocketContext.Provider>
      </Grid>
    );
  }
}

export default Orders;
